import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({ name: '', email: '', instagram: '', service: '', date: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="font-serif text-5xl mb-6" id="booking">{t('contact.title')}</h1>
            <p className="text-text-light mb-12 leading-relaxed max-w-md">{t('contact.description')}</p>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }} className="bg-white p-8 md:p-12 shadow-soft">
            {submitted ? <div className="text-center py-20"><h3 className="font-serif text-3xl mb-4">{t('contact.requestReceived')}</h3><p>{t('contact.requestReceivedDescription')}</p></div> : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <input required type="text" name="name" value={formData.name} onChange={handleChange} placeholder={t('contact.fullName')} className="w-full border-b border-text-dark/20 py-2 focus:outline-none focus:border-text-dark bg-transparent transition-colors" />
                <input required type="email" name="email" value={formData.email} onChange={handleChange} placeholder={t('contact.email')} className="w-full border-b border-text-dark/20 py-2 focus:outline-none focus:border-text-dark bg-transparent transition-colors" />
                <input type="text" name="instagram" value={formData.instagram} onChange={handleChange} placeholder={t('contact.instagram')} className="w-full border-b border-text-dark/20 py-2 focus:outline-none focus:border-text-dark bg-transparent transition-colors" />
                <button type="submit" className="w-full py-4 bg-text-dark text-white uppercase tracking-widest text-sm hover:bg-black transition-colors">{t('contact.submit')}</button>
              </form>
            )}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
